<script>
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import IconSearch from "@js/components/Icons/IconSearch.vue";
import {Link} from "@inertiajs/vue3";
import IconMapPoint from "@js/components/Icons/IconMapPoint.vue";
import SalesDepartmentPhone from "@js/components/Sections/Links/SalesDepartmentPhone.vue";
import TopBarMobileSearchInput from "@js/components/TopBar/Components/TopBarMobileSearchInput.vue";
import IconLogo from "@js/components/Icons/IconLogo.vue";
import {usePopupsControlStore} from "@js/store/PopupsControlStore.js";
import ModalSelect from "@js/components/Input/ModalSelect.vue";
import {contacts} from "@js/company_details.ts";
import TopBarContactsBlock from "@js/components/TopBar/Components/TopBarContactsBlock.vue";
import {formatPhone} from "@js/helpers.ts";
import IconChevronDown from "@js/components/Icons/IconChevronDown.vue";

export default {
    name: "MobileTopBar",
    computed: {
        formattedPhone() {
            return formatPhone(contacts.sales_department_phone);
        }
    },
    props: {
        with_logo: false,
    },
    components: {
        IconChevronDown,
        TopBarContactsBlock,
        ModalSelect,
        IconLogo,
        TopBarMobileSearchInput,
        SalesDepartmentPhone,
        IconMapPoint,
        Link,
        IconSearch,
        OnlyMobile
    },
    setup() {
        const popupStore = usePopupsControlStore()

        return {popupStore, contacts}
    }
}
</script>

<template>
    <OnlyMobile :maxSize="1024">
        <header class="mb-5">
            <template v-if="!with_logo">
                <div class="container pt-4">
                    <div class="flex items-center justify-between text-sm font-semibold">
                        <div @click.prevent="popupStore.showCitySelectPopup"
                             class="flex items-center gap-x-1 text-base">
                            <IconMapPoint class="w-4 h-4 self-center text-navHoverColor"/>
                            <span class="self-center text-sm mt-0.5">
                                 {{ popupStore.selectedCity.name }}
                            </span>
                        </div>
                        <ModalSelect :buttonClass="'group bg-transparent font-normal'" widthClass="w-[350px]"
                                     :closeOnClick="false" :withCloseButton="true">
                            <template #button>
                                <div class="text-sm font-bold">
                                    {{ formattedPhone }}
                                </div>
                            </template>
                            <template #menu class="w-full">
                                <TopBarContactsBlock/>
                            </template>
                        </ModalSelect>
                    </div>
                    <div class="mt-3">
                        <TopBarMobileSearchInput/>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="container flex items-center justify-between h-[80px] mb-1">
                    <div class="-mt-5">
                        <IconLogo class="h-auto w-[210px]"/>
                    </div>
                    <div class="flex flex-col items-end justify-center text-sm font-bold -mt-5">
                        <ModalSelect :buttonClass="'group bg-transparent font-normal'" widthClass="w-[350px]"
                                     :closeOnClick="false" :withCloseButton="true">
                            <template #button>
                                <div class="flex flex-col items-end justify-center text-sm font-bold">
                                    <div class="flex items-end gap-x-1 text-base">
                                        <IconMapPoint class="w-4 h-4 self-center text-navHoverColor"/>
                                        <span class="self-center text-sm mt-0.5">
                                           {{ popupStore.selectedCity.name }}
                                       </span>
                                    </div>
                                    <div class="text-sm font-bold">
                                        {{ formattedPhone }}
                                    </div>
                                </div>
                            </template>
                            <template #menu class="w-full">
                                <TopBarContactsBlock/>
                            </template>
                        </ModalSelect>
                    </div>
                </div>
                <div class="container -mt-6">
                    <TopBarMobileSearchInput/>
                </div>
            </template>
        </header>
    </OnlyMobile>
</template>

<style scoped lang="scss">

</style>
